import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="bg-slate-200 dark:bg-slate-900 text-muted py-6 mt-auto">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <p className="font-semibold text-title">SecureCoop</p>
        <p className="text-sm mt-1">{t.securityPlatform}</p>
        <p className="text-xs mt-3">Developed by ScripTeus</p>
      </div>
    </footer>
  );
}
